module.exports = __webpack_public_path__ + "7ae9b8ba7886341831bf7c85a0da40d0.eot";


//////////////////
// WEBPACK FOOTER
// ./node_modules/open-sans-fontface/fonts/Bold/OpenSans-Bold.eot
// module id = 1003
// module chunks = 0